import React from 'react';
import { baseConfig } from '../../config/algolia.js';
import SponsoredContentResult from './SponsoredContentResult';
import { Configure, Index } from 'react-instantsearch';

/**
 * Utils
 */

const { product_families_index } = baseConfig;

const HITS_PER_PAGE = 4;

const SponsoredContentContainer = () => {
  const storedProducts = [];
  for (const [index, value] of window.Jbhifi.collection.hero.entries()) {
    storedProducts.push(value);
  }
  if (storedProducts.length < 1) {
    return <></>;
  }

  return (
    <Index indexId="sponsored_products" indexName={product_families_index}>
      <Configure
        hitsPerPage={HITS_PER_PAGE}
        clickAnalytics
        page={0}
        query=""
        filters={
          storedProducts
            .map(sku => `sku: ${sku} OR skus: ${sku} OR `)
            .join('')
            .slice(0, -4) + ' AND (price > 0 AND product_published = 1 AND availability.displayProduct = 1)'
        }
        distinct
      />
      <SponsoredContentResult storedProducts={storedProducts} />
    </Index>
  );
};

export default SponsoredContentContainer;
